import { TableHelp } from "../help/table_help";

const {ccclass, property} = cc._decorator;

//玩家位置信息
export interface SeatConfig
{
    goldVec2:cc.Vec2

    smallCard:cc.Vec2;

    goldTarget:cc.Vec2;

    goldNumb:cc.Vec2;

    bubble_child:number;//气泡的锚点

    bubblepos:cc.Vec2;//气泡的位置

    bubbleType:string;//气泡的类型

    patternpos:cc.Vec2;//牌型位置
}

export enum GoldDirect{
    Top = 0,
    Left = 1,
    Bottom = 2,
    Right = 3,
}

@ccclass
export  class SeatState extends cc.Component {

    //金币位置
    @property(cc.Vec2)
    goldVec2:cc.Vec2 = null;

    @property(cc.Vec2)
    smallCards:cc.Vec2 = null;

    @property(cc.Vec2)
    dealer:cc.Vec2 = null;

    @property(cc.Vec2)
    goldTarget:cc.Vec2 = null;

    @property(cc.Vec2)
    goldNumb:cc.Vec2 = null;

    @property(cc.Float)
    bubble_anchorx:number = 0;

    @property(cc.Vec2)
    bubblepos:cc.Vec2 = null;

    @property(cc.String)
    bubbleType:string = '';

    @property(cc.Vec2)
    patternpos:cc.Vec2 = null;

    getPosition(){
        return this.node.position;
    }

    //更新节点位置
    refreshNodeInfo(func:Function){
        if (func) {
            let curConfig:SeatConfig = {
                goldVec2:this.goldVec2,
                goldNumb:this.goldNumb,
            
                smallCard:this.smallCards,
                goldTarget:this.goldTarget,
                //气泡
                bubble_child:this.bubble_anchorx,
                bubblepos:this.bubblepos,
                bubbleType:this.bubbleType,
                patternpos:this.patternpos,
            };
            func(curConfig);
        }
    }
}
